// @flow

import React from 'react';

import {DocumentAlertBox} from './DocumentAlertBox';
import {gt} from 'app/utils/i18n';
import {getContentType} from 'app/utils/content-type';
import type {VersionableDocumentTypes} from 'app/general/types';

type Props = {contentType: VersionableDocumentTypes, editDocumentUrl: string};

export const DocumentVersionLocked = ({
  contentType,
  editDocumentUrl,
}: Props) => {
  const ct = getContentType(contentType).name;

  const editDocumentLink = <a href={editDocumentUrl}>Most recent draft</a>;

  return (
    <DocumentAlertBox
      type="danger"
      icon="fa-exclamation-triangle"
      title={gt('This %(ct)s version is not editable', {ct})}
      content={
        <div>
          {gt(
            'The %(ct)s may still be edited by following this link %(editDocumentLink)s',
            {ct, editDocumentLink}
          )}
        </div>
      }
    />
  );
};
